import AdminCommonAPICall from "src/service/AdminAPICalls/AdminCommonAPICall";

class AdminCommonRepository {

    getRoleList = async (isEditable = true) => {
        return await new AdminCommonAPICall().getRoleList({ isEditable });
    };

    getOrganizationList = async () => {
        return await new AdminCommonAPICall().getOrgList();
    };

    fetchBomManagementList = async (params) => {
        return await new AdminCommonAPICall().fetchBomManagementList(params);
    };

    fetchComplianceManagementList = async (params) => {
        return await new AdminCommonAPICall().fetchComplianceManagementList(params);
    };
    
    exportComplianceManagementSurvey = async (params) => {
        return await new AdminCommonAPICall().exportComplianceManagementSurvey(params);
    };

    fetchBomDetailsManagementList = async (params) => {
        return await new AdminCommonAPICall().fetchBomDetailsManagementList(params);
    };

}

export default AdminCommonRepository;